import { ParquesIndustrialesComponent } from './parques-industriales.component';
import { Routes } from '@angular/router';
export const ParquesIndustrialesRoutes: Routes  = [{
    path: '',
    children:[
        {
            path: '',
            component: ParquesIndustrialesComponent,
        },
    ]
}];